import { render, staticRenderFns } from "./registerSoUserMobile.vue?vue&type=template&id=cdd320b2"
import script from "./registerSoUserMobile.vue?vue&type=script&lang=js"
export * from "./registerSoUserMobile.vue?vue&type=script&lang=js"
import style0 from "./registerSoUserMobile.vue?vue&type=style&index=0&id=cdd320b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports